import React, { useEffect, useState } from 'react';
import { TdsButton, TdsIcon, } from '@scania/tegel-react';
import ChainComponent from './ChainComponent';
import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react';
import { ChainItemTypeEnum } from '../../helpers/dataHelper';


interface ChainEditPropType {
  variable?: VariableDetail
  action: "create" | "edit"
}

const ChainEdit = ({ variable, action }: ChainEditPropType) => {
  const { setError, getValues, setValue, unregister} = useFormContext()
  const chainItems = getValues("chain") || [] as ChainItemType[]
  const [chainVariables, setChain] = useState<Array<ChainItemType> | undefined>(variable?.chain || [])

  const onAddToChainClick = () => {
    const chainItem: ChainItemType = {} as ChainItemType;
    if (chainItems.length === 0) {
      chainItem.type = ChainItemTypeEnum.Input;
    }
    chainItems.push(chainItem);
    setValue("chain", chainItems)
    setChain(chainItems)
  }
  const onRemoveChainItemClick = (index: number) => {
    unregister(`chain.${index}`);
    unregister(`chain.${index}`);
    chainItems.splice(index, 1);
    setValue("chain", chainItems);
    setChain(chainItems)
  }

  const onItemTypeChange = (index: number, newType: ChainItemTypeEnum) => {
    if (index === 0 && newType !== ChainItemTypeEnum.Input) {
      setError(`chain.${index}.type]`, { type: "value" })
    } else {
      chainItems[index] = { type: newType };
      setValue("chain", chainItems)
      setChain(chainItems)
    }
  }

  // const onItemAttributeChange = (index: number, attribute: string, newValue: any) => {
  //   // chainItems[index][attribute] = newValue;
  //   // setChainVariable(chainItems);
  // }
  useEffect(() => {
    setChain(variable?.chain)
  }, [variable])

  return (<>
    <div className='tds-u-flex-end'>
      <TdsButton className='' text='Add' size='sm' onClick={onAddToChainClick}>
        <TdsIcon slot="icon" size="20px" name="plus" />
      </TdsButton>
    </div>
    {chainVariables?.map((chainItem: ChainItemType, index: number) => {
      return <ChainComponent
        index={index}
        key={`chain-com-${index}`}
        chainItem={chainItem}
        onRemoveChainItemClick={() => onRemoveChainItemClick(index)}
        onItemTypeChange={(newType: ChainItemTypeEnum) => onItemTypeChange(index, newType)}
      />
    })}
    {(!chainVariables || chainVariables.length === 0) && <div className='tds-container-fluid tds-u-p1'>
      <div className='tds-row'>
        <div className="tds-col-md-12 tds-u-mt1">
          Click the add button to start adding Chain variables.
        </div>
      </div>
    </div>
    }
  </>
  );
}

export default observer(ChainEdit)